module.exports = __webpack_public_path__ + "officialStatic/img/product-jxc.ce88f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-jxc.png
// module id = qabr
// module chunks = 0